"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview14_exports = {};
__export(GeodesPreview14_exports, {
  default: () => GeodesPreview14_default
});
module.exports = __toCommonJS(GeodesPreview14_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.7539 5.07422H9.17188C9.02865 5.07422 8.90495 5.1263 8.80078 5.23047C8.70964 5.32161 8.66406 5.4388 8.66406 5.58203C8.66406 5.72526 8.70964 5.84896 8.80078 5.95312C8.90495 6.04427 9.02865 6.08984 9.17188 6.08984H14.5625L6.16406 14.4883C6.0599 14.5794 6.00781 14.6966 6.00781 14.8398C6.00781 14.9701 6.0599 15.0872 6.16406 15.1914C6.25521 15.2826 6.3724 15.3281 6.51562 15.3281C6.65885 15.3281 6.77604 15.2826 6.86719 15.1914L15.3242 6.71484V12.2422C15.3242 12.3854 15.3698 12.5091 15.4609 12.6133C15.5651 12.7044 15.6888 12.75 15.832 12.75C15.9753 12.75 16.0924 12.7044 16.1836 12.6133C16.2878 12.5091 16.3398 12.3854 16.3398 12.2422V5.66016C16.3398 5.54297 16.3008 5.4388 16.2227 5.34766C16.1576 5.24349 16.0729 5.17188 15.9688 5.13281C15.9297 5.10677 15.8906 5.09375 15.8516 5.09375C15.8255 5.08073 15.793 5.07422 15.7539 5.07422Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview14 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview14_default = SvgGeodesPreview14;
